import React from "react";
import { BrowserRouter as Router, Navigate, Route, Routes, useLocation } from "react-router-dom";
import DashboardPage from "./pages/dashboard/DashboardPage";

import { useSelector } from "react-redux";
import { selectCurrentToken, selectCurrentUser } from "./redux/reducers/authSlice";

import MisContratosCat from "./pages/dashboard/misContratosCat/MisContratosCat";
import CalculadoraCat from "./pages/dashboard/calculadoraCat/CalculadoraCat";
import LicitacionesCat from "./pages/dashboard/licitacionesCat/LicitacionesCat";
import PersonasCat from "./pages/dashboard/personasCat/PersonasCat";
import ContratosCat from "./pages/dashboard/contratosCat/ContratosCat";
import CotizadorCat from "./pages/dashboard/contratosCat/CotizadorCat";
import TitularidadesCat from "./pages/dashboard/titularidadesCat/TitularidadesCat.jsx";
import CuponesCat from "./pages/dashboard/cuponesCat/CuponesCat";
import ComisionesCat from "./pages/dashboard/comisionesCat/ComisionesCat";
import PagosCat from "./pages/dashboard/pagosCat/PagosCat";
import IndicesCat from "./pages/dashboard/indicesCat/IndicesCat";
import NoticiasCat from "./pages/dashboard/noticiasCat/NoticiasCat";
import LoginPage from "./pages/login/LoginPage";
import ResetPassword from "./pages/resetPassword/ResetPassword";
import CobranzasCat from "./pages/dashboard/cobranzasCat/CobranzasCat"
import RolesCat from "./pages/dashboard/rolesCat/RolesCat"
import RedirectCat from "./pages/redirect/Redirect"
import EventosAdjudicacionCat from "./pages/dashboard/eventosAdjudicacion/eventosAdjudicacionCat";
import EdificiosCat from "./pages/dashboard/edificiosCat/EdificiosCat"

import { ThemeProvider, createTheme } from '@mui/material/styles';
import themeParams from './theme.js';
//A: poner todo en español para material UI, LEER: https://material-ui.netlify.app/zh/x/react-data-grid/localization/
import { LicenseInfo } from '@mui/x-license-pro';
LicenseInfo.setLicenseKey(process.env.REACT_APP_MUI_PRO_KEY);
//console.log(process.env);

//A: poner todo en español para material UI, LEER: https://material-ui.netlify.app/zh/x/react-data-grid/localization/

const theme = createTheme(themeParams);

const routesProtected = {
  "personas/humana": "Admin",
  "personas/juridica": "Admin",
  "contratos": "Admin",
  "comisiones": "Admin",
  "pagos": "Admin"
}
const authorized = (user, path) => {

  return true
}
const match = (array, subStr) => array.find(element => {
  if (element.includes(subStr)) {
    //console.log("element: " + element + " substr: " + subStr);
    return true;
  }
});

const ProtectedRoute = ({ children }) => {
  const token = useSelector(selectCurrentToken);
  const user = useSelector(selectCurrentUser);
  const location = useLocation();
  let route = location.pathname.replace('/dashboard/', '').toLowerCase();

  if (token == null || user == null) {
    return <Navigate to="/login" replace />;
  }

  if (!authorized(user, route)) {
    return <Navigate to="/dashboard/miscontratos" replace />;
  }
  //A: the user not have the permission so we redirect to /dasboard/miscontratos

  return children;
};

export default function App() {
  return (
    <ThemeProvider theme={theme}>
      <Router>
        <Routes>
          <Route path="/dashboard/*" element={<ProtectedRoute> <DashboardPage /> </ProtectedRoute>}>
            <Route path="miscontratos/*" element={<MisContratosCat />} />
            <Route path="calculadora" element={<CalculadoraCat />} />
            <Route path="licitaciones" element={<LicitacionesCat />} />
            <Route path="personas/*" element={<PersonasCat />} />
            <Route path="contratos/*" element={<ContratosCat />} />
            <Route path="contratos/crear-contratos" element={<CotizadorCat />} />
            <Route path="contratos/titularidades" element={<TitularidadesCat />} />
            <Route path="contratos/cupones" element={<CuponesCat />} />
            <Route path="comisiones" element={<ComisionesCat />} />
            <Route path="pagos" element={<PagosCat />} />
            <Route path="indices" element={<IndicesCat />} />
            <Route path="noticias" element={<NoticiasCat />} />
            <Route path="cobranzas/*" element={<CobranzasCat />} />
            <Route path="roles" element={<RolesCat />} />
            <Route path="eventosadjudicacion" element={<EventosAdjudicacionCat />} />
            <Route path="edificios" element={<EdificiosCat />} />
          </Route>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/reset-password/:token" element={<ResetPassword />} />
          <Route path="/redirect/*" element={<RedirectCat />} />
        </Routes>

      </Router>
    </ThemeProvider>
  );
}
